import { render, staticRenderFns } from "./Tema.vue?vue&type=template&id=2fe34182&"
import script from "./Tema.vue?vue&type=script&lang=js&"
export * from "./Tema.vue?vue&type=script&lang=js&"
import style0 from "./Tema.vue?vue&type=style&index=0&id=2fe34182&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports